export default class Archetype {
    
    cuepoints = {};
    cuepointsA = [];
    currentLive = -1;
    //currentChapterIndex = -1;
    currentCueIndex = -1;
    timesA = [];
    times = {};
    lastClicked = false;
    
    constructor(name, sdk) {
        this.name = name;
        this.sdk = sdk;
    }
    
    getDuration(i) {
        console.log(this.timesA, this.cuepointsA[i].start_second);
        let index = this.timesA.indexOf(this.cuepointsA[i].start_second);
        console.warn('getDuration', index);
        if(this.timesA[(index+1)]) {
            console.warn('cool', index);
            let next_chapId = this.times[this.timesA[(index+1)]];
            if(next_chapId) {
                let duration = this.cuepoints[next_chapId].start_second - this.cuepointsA[i].start_second;
                this.cuepoints[i].duration = duration;
                this.cuepointsA[this.cuepoints[i].indexA].duration = duration;
                return duration;
            }
            else {
                return 0;
            }
        }
        return 0;
    }
    
    addCue(data) {
        
        let duration = 0;   
        
        this.times[data.live_second] = data.value[this.name + 'Id'];
        this.timesA.push(data.live_second)
        this.timesA.sort(function(a, b){return a - b});
    
        let index = this.timesA.indexOf(data.live_second);
        if(this.timesA[(index-1)]) {
            let prev_chapId = this.times[this.timesA[(index-1)]];
            let prev_duration = data.live_second - this.cuepoints[prev_chapId].start_second;
            this.cuepoints[prev_chapId].duration = prev_duration;
            this.cuepointsA[this.cuepoints[prev_chapId].indexA].duration = prev_duration;
        }
        
        let i = this.cuepointsA.push({
            start_second: data.live_second,
            id: data.value[this.name + 'Id'],
            duration: duration
        });

        i = i - 1;
        
        this.cuepoints[data.value[this.name + 'Id']] = {
            id: data.id,
            start_second: data.live_second,
            duration: duration,
            indexA: i,
            value: data.value
        };
        
        if(!this.sdk.live.liveCuepointsManager.notEmit) {
            try {
                this.sdk.player().showTime();
            }
            catch(err) {
                
            }
            this.sdk.emit('updateLive_' + this.name, i)
            this.emitCurrentLive();
        }

    }
    
    findLiveCurrent(currentTime) {
        function isStarted(item) {
            return (item.start_second < currentTime && (item.start_second + item.duration) > currentTime);
        }
        
        function isStartedAnyway(item) {
            return (item.start_second < currentTime);
        }

        //let index = this.cuepointsA.findIndex(isStarted);
        let index;
        //if(index == -1) {
            let startSecond = 0;
            for(var i in this.cuepointsA) {
                if(this.cuepointsA[i].start_second > currentTime)
                    continue;
                if(this.cuepointsA[i].start_second > startSecond) {
                    startSecond = this.cuepointsA[i].start_second;
                    index = i;
                }
            }
        //}
        
        if (index != this.currentCueIndex) {
            if (index < 0)
                index = -1;
			
            console.warn(this.name, index, this.currentCueIndex)
            try {
                this.sdk.player().showTime();
            }
            catch(err) {
                
            }
			
			console.log('currentLiveIndex_' + this.name, this.currentCueIndex, index);
            this.sdk.emit('currentLiveIndex_' + this.name, {
                oldIndex: this.currentCueIndex,
                index: index ? index : 0
            });
            this.currentCueIndex = index;
        }
    }
    
    getCurrentCue() {
        return this.cuepointsA[this.currentCueIndex];
    }

    emitCurrentLive() {
        let maxValue = Math.max.apply(null, this.cuepointsA.map(c => c.start_second));
        var index = Object.keys(this.cuepointsA).findIndex(s => this.cuepointsA[s].start_second == maxValue);
        console.log('CUREEEEEEEEEEEEEEEEEEENT LIVE ', index)
        if (this.currentLive != index) {
            try {
                this.sdk.player().showTime();
            }
            catch(err) {
                
            }
            this.sdk.emit('currentLive_' + this.name, {
                oldIndex: this.currentLive,
                index: index
            })
            this.currentLive = index;
        }
    }
    
    
    getLastClicked() {
        if(!this.lastClicked) {
            let id = 0;
            for(var i in this.cuepoints) {
                if(this.cuepoints[i].id > id) {
                    id = this.cuepoints[i].id;
                    this.lastClicked = i;
                }
            }
        }
        return this.lastClicked;
    }
    
}


// WEBPACK FOOTER //
// ./src/Sdk/LiveCuepoints/Archetype.js